import { render, staticRenderFns } from "./TicketIssueComment.vue?vue&type=template&id=595c78fa&scoped=true&"
import script from "./TicketIssueComment.vue?vue&type=script&lang=js&"
export * from "./TicketIssueComment.vue?vue&type=script&lang=js&"
import style0 from "./TicketIssueComment.vue?vue&type=style&index=0&id=595c78fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c78fa",
  null
  
)

export default component.exports